import { render } from "./LinesInThePressBottom.vue?vue&type=template&id=23e90352"
import script from "./LinesInThePressBottom.vue?vue&type=script&lang=js"
export * from "./LinesInThePressBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__